import { AxiosInstance } from "axios"
import { Merchant } from "./merchantTypes"

export enum SupplierMerchantsQuery {
    MERCHANTS_FOR_SUPPLIER = "merchants-for-supplier",
    ALL_MERCHANTS = "all-merchants",
}

type FetchAllMerchantsParams = Readonly<{
    supplierId: number
}>

export type MerchantsResponse = Readonly<{
    merchants: Merchant[]
}>

export async function fetchMerchantsForSupplier(
    { supplierId }: FetchAllMerchantsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MerchantsResponse> {
    const response = await axios.get(`/suppliers/${supplierId}/merchants`, {
        signal,
    })
    return response.data
}

export async function fetchAllMerchants({}, axios: AxiosInstance, signal?: AbortSignal): Promise<MerchantsResponse> {
    const response = await axios.get("/merchants", {
        signal,
    })
    return response.data
}
